/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import {
  CustomSelectContainer,
  CustomSelectStyle,
  InputLabelContainer,
  LineItem,
  TextFieldArea,
} from './styles';
import { InputError } from '../typography';
import Select from 'react-select';
import { useTheme } from '@mui/material';

export type TCustomValue = {
  label?: string;
  value?: string;
};

export interface ICustomSelectProps {
  labelValue?: string;
  value?: TCustomValue;
  validationError?: string;
  handleInputChange: (v: any) => void;
  onBlur?: (v: any) => void;
  options: any;
  name: string;
  placeholder?: string;
  isClearable?: boolean;
}

const CustomSelect = ({
  labelValue,
  handleInputChange,
  value,
  validationError,
  options,
  onBlur,
  placeholder,
  name,
  isClearable = true,
}: ICustomSelectProps) => {
  const theme = useTheme();
  const customSelectStyle = useMemo(() => CustomSelectStyle(theme), [theme]);
  return (
    <CustomSelectContainer>
      {labelValue && <InputLabelContainer>{labelValue}</InputLabelContainer>}
      <TextFieldArea>
        <LineItem />
        <Select
          value={value?.value ? value : undefined}
          onChange={(v: any) =>
            handleInputChange({
              currentTarget: { name, value: v },
              target: { name, value: v },
            })
          }
          placeholder={placeholder}
          isClearable={isClearable}
          styles={customSelectStyle}
          options={options}
          onBlur={() =>
            onBlur && onBlur({
              currentTarget: { name },
              target: { name }
            })
          }
        />
      </TextFieldArea>
      {validationError && <InputError>{validationError}</InputError>}
    </CustomSelectContainer>
  );
};

export default CustomSelect;
